import Vue from 'vue'
import App from './App.vue'
// 路由
import router from './router'
//vuex
import store from './store/'

import format from 'vue-text-format'
//路由导航守卫
import '@/permission'
import ElementUI from 'element-ui'
import moment from 'moment'
//ele样式
import 'element-ui/lib/theme-chalk/index.css'
//ele 折叠动画
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// 引用工具类
import tools from '@/utils/tools'
import BigNumber from '@/utils/bigNumber/BigNumber' // 数值计算
// axios封装
import request from '@/utils/plugin/request.js'
// 拖拽缩放组件
import VueDragResize from 'vue-drag-resize'
// 富文本组件
import VueQuillEditor from 'vue-quill-editor'
import print from 'vue-print-nb'
// 富文本样式
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
// 自定义图标
import './assets/iconfont/iconfont.css'

request.then(({ http, httpBefore, rootUrl, rootUrlBefore, ProjectId }) => {
  Vue.component('vue-drag-resize', VueDragResize)
  console.log(http, httpBefore)
  // 挂载到Vue原型
  Vue.prototype.$http = http
  Vue.prototype.$httpBefore = httpBefore
  Vue.prototype.$rootUrl = rootUrl
  Vue.prototype.$rootUrlBefore = rootUrlBefore
  Vue.prototype.$ProjectId = ProjectId

  Vue.prototype.$number = BigNumber
  Vue.prototype.$tools = tools
  Vue.config.productionTip = false

  // moment格式化时间格式
  Vue.prototype.timeDataFormat = function (time, format) {
    return moment(time).format(format)
  }
  Vue.use(VueQuillEditor /* { default global options } */)
  // Vue.use(AxiosPlugin)
  // Vue.use(operatorPlugin)
  Vue.use(format)
  Vue.use(ElementUI, { size: 'mini' })
  Vue.use(CollapseTransition)
  Vue.use(print)
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
})
